export default __webpack_public_path__ + "static/till-48bdc6db5deebc135a6162ad040ddcf5.webp";